export default "__VITE_ASSET__4e450bf0__"